<div class="d-flex">
    <div class="form-group pe-3">
        <label for="inputStartDate">Filter start date</label>
        <dx-date-box id="inputStartDate"
                     style="width: 200px"
                     name="inputStartDate"
                     [value]="startDate"
                     (valueChange)="startDate = $any($event)"></dx-date-box>
    </div>

    <div class="form-group pe-3">
        <label for="inputEndDate">Filter end date</label>
        <dx-date-box id="inputEndDate"
                     style="width: 200px"
                     name="inputEndDate"
                     [value]="endDate"
                     (valueChange)="endDate = $any($event)"></dx-date-box>
    </div>
</div>

@if (showUserFilter) {
    <div class="form-group">
        <label for="selectPerson">Person</label>
        <adapt-select-person id="selectPerson"
                             [filter]="personFilter"
                             [(person)]="person"></adapt-select-person>
    </div>
}

<div id="actionFilter"
     class="form-group">
    <label for="actionFilter">Action</label>
    <div class="d-flex">
        <div class="form-group pe-3">
            <dx-check-box id="filterActionLogin"
                          text="Login"
                          [value]="actionLogin"
                          (valueChange)="actionLogin = $any($event)"></dx-check-box>
        </div>

        <div class="form-group pe-3">
            <dx-check-box id="filterActionLogout"
                          text="Logout"
                          [value]="actionLogout"
                          (valueChange)="actionLogout = $any($event)"></dx-check-box>
        </div>
    </div>
</div>

<div id="resultFilter"
     class="form-group">
    <label for="resultFilter">Result</label>
    <div class="d-flex">
        <div class="form-group pe-3">
            <dx-check-box id="filterResultSuccess"
                          text="Success"
                          [value]="resultSuccess"
                          (valueChange)="resultSuccess = $any($event)"></dx-check-box>
        </div>

        <div class="form-group pe-3">
            <dx-check-box id="filterResultFailure"
                          text="Failure"
                          [value]="resultFailure"
                          (valueChange)="resultFailure = $any($event)"></dx-check-box>
        </div>
    </div>
</div>

<div id="reasonFilter"
     class="form-group">
    <label for="reasonFilter">Failure Reason</label>
    <div class="d-flex">
        <div class="form-group pe-3">
            <dx-check-box id="filterReasonUnknownUsr"
                          text="Unknown user"
                          [value]="reasonUnknownUsr"
                          (valueChange)="reasonUnknownUsr = $any($event)"></dx-check-box>
        </div>

        <div class="form-group pe-3">
            <dx-check-box id="filterReasonIncorrectPswd"
                          text="Incorrect password"
                          [value]="reasonIncorrectPswd"
                          (valueChange)="reasonIncorrectPswd = $any($event)"></dx-check-box>
        </div>

        <div class="form-group pe-3">
            <dx-check-box id="filterReasonOther"
                          text="Other"
                          [value]="reasonOther"
                          (valueChange)="reasonOther = $any($event)"></dx-check-box>
        </div>
    </div>
</div>

<div class="form-group">
    <button adaptButtonIcon="fal fa-fw fa-sign-in"
            class="btn btn-primary"
            data-test="submit-btn"
            type="submit"
            [adaptBlockingClick]="getAuthResults">FETCH!</button>
</div>

<dx-data-grid [dataSource]="authList"
              [allowColumnReordering]="true"
              [allowColumnResizing]="true"
              [columnAutoWidth]="true"
              [rowAlternationEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true">
    <!-- Options -->
    <dxo-data-grid-header-filter [visible]="true"> </dxo-data-grid-header-filter>
    <dxo-data-grid-filter-row [visible]="true"> </dxo-data-grid-filter-row>
    <dxo-data-grid-column-chooser [enabled]="false"> </dxo-data-grid-column-chooser>
    <dxo-data-grid-export [enabled]="true"
                          fileName="AuthAudit"> </dxo-data-grid-export>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>

    <!-- Columns -->
    <dxi-data-grid-column caption="User Email"
                          dataField="partitionKey"
                          dataType="string"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Timestamp"
                          dataField="timestamp"
                          dataType="date"
                          [format]="dateFormat"
                          sortOrder="desc"
                          [sortIndex]="0"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Action"
                          dataField="Action"
                          dataType="string"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Result"
                          dataField="Result"
                          dataType="string"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Failure Reason"
                          dataField="Reason"
                          dataType="string"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Origin"
                          dataField="Origin"
                          dataType="string"> </dxi-data-grid-column>
</dx-data-grid>
